import React from 'react';

import type { HandlerRecord } from '@vlabs/api/artemy/model';

import { ViewCard, ViewRowTitle } from '../components';
import { useHandlerViewPageTranslation } from '../i18n';
import { extractFilters, hasFilters } from '../viewModel';
import { FilterRows } from './FilterRows';

interface TagsSectionProps {
  handler: HandlerRecord;
}

function TagsSection({ handler }: TagsSectionProps): React.JSX.Element | null {
  const { t: tView } = useHandlerViewPageTranslation();
  const tagsPolicy = handler.policies.conditional_tags_policy ?? [];
  if (tagsPolicy.length === 0) return null;

  return (
    <React.Fragment>
      {tagsPolicy.map((item, index) => (
        <ViewCard
          header={(
            <ViewRowTitle label={tView('tags.tag')}>
              {item.tag}
            </ViewRowTitle>
          )}
          // eslint-disable-next-line react/no-array-index-key
          key={`${item.tag}-${index}`}
          value={`tag-${index}`}
        >
          {hasFilters(extractFilters(item.filters))
            ? <FilterRows filters={item.filters} />
            : undefined}
        </ViewCard>
      ))}
    </React.Fragment>
  );
}

export { TagsSection };
